import React from 'react';

import {
  EntitlementDetails as Entitlement,
  SubscriptionScheduleAction,
} from '@css-xp/graphtypes/src/generated-types-new';
import { getFormattedDateString, InfoPanel } from '@css-xp/base';
import moment from 'moment';
import { DATE_FORMAT } from '@atlassian/cssxp-typescommon';
import { isDeletionPendingEntitlement } from '@atlassian/cssxp-utils-entitlement';

const EntitlementPageInfoPanel = ({ entitlement }: { entitlement?: Entitlement }) => {
  if (!entitlement) return null;

  const { scheduledChanges = {}, deletedProductDetails = {} } = entitlement;
  if (
    scheduledChanges?.nextChangeTimestamp &&
    scheduledChanges?.subscriptionScheduleAction === SubscriptionScheduleAction.CANCEL
  ) {
    return (
      <InfoPanel
        type="warning"
        message={`This entitlement is scheduled for deactivation on         
        ${getFormattedDateString({ date: scheduledChanges?.nextChangeTimestamp.toString() })}`}
      />
    );
  }

  if (deletedProductDetails?.deletedOn && isDeletionPendingEntitlement(entitlement)) {
    return (
      <InfoPanel
        type="warning"
        message={`The product data for this entitlement is scheduled for deletion on 
        ${getFormattedDateString({ date: deletedProductDetails?.deletedOn })}`}
      />
    );
  }

  return null;
};

export default EntitlementPageInfoPanel;
